import { ErrorHandler, Injectable } from "@angular/core";
import { LoadingService } from "src/app/common/services/loading/loading.service";
import { logger } from 'src/app/common/services/logging/logging.service';

@Injectable({
    providedIn: 'root'
  })
export class MEErrorHandler implements ErrorHandler {

    constructor(private srvLoading: LoadingService) {}

    handleError(error: any): void {
        logger.error(error);
        // this.srvLoading.available();
    }
}
